module.exports = __webpack_public_path__ + "static/media/img-add.4e8621ac.svg";